module.exports = __webpack_public_path__ + "static/media/card.487b0cd2.png";